/* Storeyza mega menu: hover intent on a mouse, page dimming, Escape (§C.1, §C.5, WCAG 1.4.13).
   Dawn opens the mega menu on click only. On a mouse (hover: hover, pointer: fine) it now opens on hover after
   OPEN_DELAY and closes CLOSE_DELAY after the pointer leaves; a mouse click on an open top-level item goes to its
   URL. Round 2: while a panel is open, another item takes over only when the pointer rests SWITCH_DELAY on its own
   label (not its hover bridge, switched off by CSS meanwhile), and an open panel stays open while the pointer is in
   the strip between the menu row and the panel (full header width), so a diagonal move toward it never flips it. Touch and keyboard keep Dawn's click / Enter / Escape behaviour. Escape also closes a panel opened by hover
   while focus is elsewhere (content on hover must be dismissible). While a panel is open, body gets .sz-menu-open
   (the page behind dims, CSS in storeyza.css). In the theme editor a panel never closes by itself and a click never
   navigates, so Karim can edit its cards in the sidebar (storeyza-editor.js opens it on block select).
   Loaded once by snippets/storeyza-mega-menu.liquid. */
(() => {
  if (window.__szMenuHover) return;
  window.__szMenuHover = true;

  const mouse = matchMedia('(hover: hover) and (pointer: fine)');
  const OPEN_DELAY = 120;
  const SWITCH_DELAY = 260;
  const CLOSE_DELAY = 250;
  const SEL = '.header__inline-menu details';
  const editor = () => !!(window.Shopify && Shopify.designMode);

  let pointerY = -1;
  document.addEventListener('mousemove', (event) => { pointerY = event.clientY; }, { passive: true });
  /* the pointer is in the strip between the item's label and the top of its open panel */
  const inStrip = (details) => {
    const summary = details.querySelector('summary');
    const panel = details.querySelector('.mega-menu__content');
    if (!summary || !panel || !details.hasAttribute('open')) return false;
    return pointerY >= summary.getBoundingClientRect().bottom - 2 && pointerY <= panel.getBoundingClientRect().top + 8;
  };

  const openOther = (details) => [...document.querySelectorAll(SEL + '[open]')].some((d) => d !== details);

  const dim = () => document.body.classList.toggle('sz-menu-open', !!document.querySelector(SEL + '[open]'));

  const setOpen = (details, open) => {
    const summary = details.querySelector('summary');
    if (open) details.setAttribute('open', '');
    else details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', String(open));
    dim();
  };

  const bind = (root) => {
    root.querySelectorAll(SEL).forEach((details) => {
      if (details.dataset.szHover) return;
      details.dataset.szHover = '1';
      const summary = details.querySelector('summary');
      let closeTimer;

      details.addEventListener('toggle', dim);

      const schedule = () => {
        clearTimeout(details.szOpenTimer);
        details.szOpenTimer = setTimeout(() => {
          document.querySelectorAll(SEL + '[open]').forEach((other) => other !== details && setOpen(other, false));
          setOpen(details, true);
        }, openOther(details) ? SWITCH_DELAY : OPEN_DELAY);
      };

      details.addEventListener('mouseenter', () => {
        if (!mouse.matches) return;
        clearTimeout(closeTimer);
        /* another panel is open: only the item's own label may take over (summary listeners below) */
        if (details.hasAttribute('open') || openOther(details)) return;
        schedule();
      });

      if (summary) {
        summary.addEventListener('mouseenter', () => {
          if (!mouse.matches || details.hasAttribute('open')) return;
          schedule();
        });
        summary.addEventListener('mouseleave', () => {
          if (mouse.matches && openOther(details)) clearTimeout(details.szOpenTimer);
        });
      }

      details.addEventListener('mouseleave', () => {
        if (!mouse.matches) return;
        clearTimeout(details.szOpenTimer);
        if (editor()) return;
        const close = () => {
          if (inStrip(details)) closeTimer = setTimeout(close, 100);
          else setOpen(details, false);
        };
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });

      if (summary) {
        summary.addEventListener('click', (event) => {
          const href = summary.dataset.href;
          if (mouse.matches && event.detail > 0 && href && details.hasAttribute('open') && !editor()) {
            event.preventDefault();
            window.location.href = href;
          }
        });
      }
    });
  };

  /* Escape closes any open panel, wherever the focus is; focus goes back to its item only if it was inside */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(SEL).forEach((details) => {
      clearTimeout(details.szOpenTimer);
      if (!details.hasAttribute('open')) return;
      const hadFocus = details.contains(document.activeElement);
      setOpen(details, false);
      const summary = details.querySelector('summary');
      if (hadFocus && summary) summary.focus();
    });
  });

  bind(document);
  document.addEventListener('shopify:section:load', (event) => {
    bind(event.target);
    dim();
  });
  document.addEventListener('shopify:section:unload', () => setTimeout(dim));
})();
